import { useEffect, useState } from 'react';

export const useScreenResize = (): number | undefined => {
  const [size, setSize] = useState<number | undefined>(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setSize(window.innerWidth);
    });
    return () => {
      window.removeEventListener('resize', () => {
        setSize(window.innerWidth);
      });
    };
  }, []);

  return size;
};
